import { render, staticRenderFns } from "./Section5a.vue?vue&type=template&id=23955b3d"
import script from "./Section5a.vue?vue&type=script&lang=js"
export * from "./Section5a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports